import React from 'react';
import './App.css';
import logo from './assets/logo.png';

function App() {
  return (
    <div className="construction-page">
      <div className="content-container">
        <div className="logo-container">
          <img src={logo} alt="Minu Payment Solutions" className="logo" />
        </div>
        <h1 className="title">Website Under Construction</h1>
        <p className="message">
          We're working hard to bring you a new and improved online experience. Thank you
          for your patience — we look forward to welcoming you back shortly.
        </p>
        <div className="news-link">
          <span>News article: </span>
          <a href="https://economist.kg/novosti-kompanii/2025/04/03/mongol-id-holdings-i-bank-kompanon-ughlubliaiut-stratieghichieskoie-partnierstvo-dlia-vniedrieniia-platiezhnykh-innovatsii-v-kyrghyzstanie/?fbclid=IwY2xjawJ7z81leHRuA2FlbQIxMQBicmlkETFJSzNrUk9COFlBUlc2dFB0AR4u9lyqIzyceWhik_cGrlO9vutOExlq5YKK4MIORr9Qd18s3wQfKsschaePKw_aem_kSwTA0I41YAVBkIN7A_2yg" target="_blank" rel="noopener noreferrer">
            Economist.kg
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
